import { NavMarker } from 'react-rhumb';
import { useHistory, Redirect } from 'react-router-dom';
import ChangeDefaultHomepageModal from 'setup-guide-components/components/modal/ChangeDefaultHomepageModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useGlobalHomeEligibility } from 'setup-guide-api/dataFetchingClient/queries/globalHomeEligibility';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { persistHomepageModalClosed } from '../utils/onboardingSettingsUtils';
import { getQueryParam, redirectTo } from '../utils/urls';
import { getChangeDefaultHomepageModalI18nPrefix } from '../utils/changeDefaultHomepage';
import { jsx as _jsx } from "react/jsx-runtime";
const ChangeDefaultHomepageModalPage = () => {
  const shouldPersistDecision = getQueryParam('persistClose');
  const languageFile = getQueryParam('homepageModalLang');
  const i18nprefix = getChangeDefaultHomepageModalI18nPrefix(languageFile);
  const history = useHistory();
  const {
    isEligibleForGlobalHome,
    hasGlobalHomeError,
    loading: isLoadingGlobalHome
  } = useGlobalHomeEligibility();
  function handleCloseChangeDefaultHomepageModal(navConfig) {
    if (shouldPersistDecision) {
      persistHomepageModalClosed();
    }
    if (!navConfig || !navConfig.path) {
      // Modal closed without selecting a new homepage
      history.replace({
        pathname: '/',
        state: {
          redirectedFromChangeDefaultHomepageModal: true
        }
      });
    } else {
      redirectTo(navConfig.path);
    }
  }
  if (isLoadingGlobalHome) {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.loading"
      }),
      layout: "centered",
      showLabel: true
    });
  }
  if (isEligibleForGlobalHome || hasGlobalHomeError) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: "/"
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "CHANGE_HOMEPAGE_MODAL_SHOWN",
    children: /*#__PURE__*/_jsx(ChangeDefaultHomepageModal, {
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${i18nprefix}.updateYourHomepageModal.description`
      }),
      heading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${i18nprefix}.updateYourHomepageModal.heading`
      }),
      onClose: handleCloseChangeDefaultHomepageModal
    })
  });
};
export default ChangeDefaultHomepageModalPage;